import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon/Icon';

const SearchResultItem = ({ text, icon, secondaryText }) => (
    <div>
        { icon && <Icon className="search__dropdown-item__icon mr-2" icon={ icon } /> }
        <span>
            { text }
            { secondaryText && (
                <span className="search__dropdown-item__secondary d-block">
                    { secondaryText }
                </span>
            ) }
        </span>
    </div>
);

SearchResultItem.defaultProps = {
    icon: null,
    secondaryText: null,
};

SearchResultItem.propTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.string,
    secondaryText: PropTypes.string,
};

export default SearchResultItem;
